import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchJobsStatusList = createAsyncThunk("fetchJobStatus", async ({ identifier, sub }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`status/list?identifier=${identifier}&sub=${sub}`, config);

	return response.data.data;
});

const jobsStatusListSlice = createSlice({
	name: "JobStatusList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchJobsStatusList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchJobsStatusList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchJobsStatusList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default jobsStatusListSlice.reducer;
